// extracted by mini-css-extract-plugin
export var categories = "index-module--categories--rSefQ";
export var container = "index-module--container--Ph8hs";
export var h1 = "index-module--h1--jATFC";
export var isActive = "index-module--isActive--cmRfJ";
export var tabBar = "index-module--tabBar--dvRfS";
export var tag = "index-module--tag--gPfSK";
export var tags = "index-module--tags--WWqV6";
export var title = "index-module--title--xHvG5";